<template>
  <div class="carousel-item" @click="handleClick">
    <slot />
  </div>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  clicked: [];
}>();

// Methods
const handleClick = () => {
  emit("clicked");
};
</script>

<style lang="scss">
@import "@styles/layout/breakpoint";
@import "@styles/themes/sls-theme/tokens/spacing";

.carousel-item {
  flex: 0 0 auto;
  margin: $spacing-05 $spacing-03;
  min-height: 3rem;
  scroll-snap-align: start;

  @include media("mobile") {
    max-width: 343px;
    width: calc(100% - #{$spacing-05});
  }

  @include media("tablet") {
    width: calc((100% / 2) - #{$spacing-05});
  }

  @include media("desktop") {
    width: calc((100% / 3) - #{$spacing-05});
  }

  .card-component {
    width: 100%;
  }
}

.carousel {
  > .controls {
    .bx--btn {
      border: 1.5px solid;
    }
  }
}
</style>
